import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { saveAs } from 'file-saver';
import { ModalService } from '../Modal/ModalService';
import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import { SecurityService } from '../Security/SecurityService';
import DateHelpers from '@infrastructure/DateHelpers';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import { isNotNullOrUndefinedOrEmpty } from '../objectUtils';
import { ErrorsOnBeneficiary } from './beneficiary-errors.interface';
import { BenefitChoosen } from './benefit-choosen.enum';


@Injectable({
  providedIn: "root"
})

export class BeneficiaryHelperService {



  deceasedRelationshipValues = DropdownsValues.dropdownDeceasedRelationship;
  private personTypologyValues = DropdownsValues.dropDownPersonType;
  
  private scholarSituationValues = DropdownsValues.dropListScholarSituationDeathDate;

  private errorsOnBeneficiaries: ErrorsOnBeneficiary[] = [];
  constructor(private securityService: SecurityService,
    private prestacoesMorteValueObserverService: PrestacoesMorteValueObservableService) {
    
  }

  //A validação do "toDeleteTableItem" serve para quando o user remove uma linha da tabela dos habilitandos ele remover o doc das notificações da direita

  docProvaEfectividadeChange(toDeleteTableItem: boolean, existePensaoSobrevivencia: boolean,
    hadPensionCGABeforeDeath: boolean, nameOfDeceased: string, nifOfDeceased: number) {
    const validationDocAppear = this.prestacoesMorteValueObserverService
      .provaEfetividadeValidation(hadPensionCGABeforeDeath, existePensaoSobrevivencia);

    if (toDeleteTableItem || !validationDocAppear) {
      this.prestacoesMorteValueObserverService
        .changeProvaEfetividadeNotification(nameOfDeceased, nifOfDeceased, false);
    } else if (validationDocAppear) {
      this.prestacoesMorteValueObserverService
        .changeProvaEfetividadeNotification(nameOfDeceased, nifOfDeceased, true);
    }
  }
  public docFaturaOuReciboChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .faturaOuRecidoDespesaFuneralValidation( item.reimbursementFuneralBenefit);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeFaturaOuRecidoDespesaFuneralNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeFaturaOuRecidoDespesaFuneralNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docCerNascimentoReqChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .certidaoNascimentoRequerenteValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeCertidaoNascimentoRequerenteNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear){
        this.prestacoesMorteValueObserverService
          .changeCertidaoNascimentoRequerenteNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docAtestadoJuntaFreguesiaChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .atestadoJuntaFreguesiaValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeAtestadoJuntaFreguesiaNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeAtestadoJuntaFreguesiaNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docDeclCompHonraChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .declCompHonraValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship);

    if (toDeleteTableItem || !validationDocAppear) {
      this.prestacoesMorteValueObserverService
        .changeDeclCompHonraNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {

      this.prestacoesMorteValueObserverService
        .changeDeclCompHonraNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docProvaEscolarChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM, deathDate:Date): void {
    

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .declProvaEscolarValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship
        , item.dateOfBirth, item.hasChargeDeceased, deathDate, item.registrationYear, item.hasIncapacity);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeProvaEscolarNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeProvaEscolarNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docComprovativoSSChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .docComprovativoSSValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship
        , item.dateOfBirth, item.hasChargeDeceased, item.hasIncapacity, item.activeProfessionalSituation);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changedocComprovativoSSNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changedocComprovativoSSNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docSentencaChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .sentencaValidation(item.survivalPensionBenefit, item.funeralAllowanceBenefit, item.deceasedRelationship
        , item.dateOfBirth, item.hasIncapacity, item.hasJudicialInterdiction);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeSentencaNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if(validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeSentencaNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docDeclaracaoIRSChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .declaracaoIRSValidation (item.survivalPensionBenefit, item.funeralAllowanceBenefit,
      item.deceasedRelationship )

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeDeclaracaoIRSNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeDeclaracaoIRSNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docDeclaracaoPensaoAlimentosChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .declaracaoPensaoAlimentosValidation(item.hasCourtAlimony, item.survivalPensionBenefit, item.deceasedRelationship);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeDeclaracaoPensaoAlimentosNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeDeclaracaoPensaoAlimentosNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docPrestacoesFamiliaresChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .docPrestacoesFamiliaresValidation(item.deceasedRelationship, item.dateOfBirth, item.hasIncapacity, item.survivalPensionBenefit, item.hasChargeDeceased);

    if (toDeleteTableItem || !validationDocAppear){
        this.prestacoesMorteValueObserverService
          .changeDocPrestacoesFamiliaresNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear)  {
        this.prestacoesMorteValueObserverService
          .changeDocPrestacoesFamiliaresNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docPSIChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .docPSIValidation(item.hasSocialPension);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeDocPSINotificationNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear)  {
        this.prestacoesMorteValueObserverService
          .changeDocPSINotificationNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docCertidaoIsensaoIRSChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .certidaoIsensaoIRSValidation(item.hasIRSExemption);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeCertidaoIsensaoIRSNotificationNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeCertidaoIsensaoIRSNotificationNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docComprovativoIBANChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .comprovativoIBANValidation(item.bankAccount);

    if (toDeleteTableItem || !validationDocAppear) {

        this.prestacoesMorteValueObserverService
          .changeComprovativoIBANNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);

    } else if(validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeComprovativoIBANNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docRequerenteHabilitadoChange(toDeleteTableItem: boolean, item: models.BeneficiaryListVM, isFunerary: boolean): void {

    const validationDocAppear = this.prestacoesMorteValueObserverService
      .requerendoValidation(isFunerary);

    if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeRequerenteHabilitandoNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
    } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeRequerenteHabilitandoNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
    }
  }

  public docBeneficiaryRepresentacaoLegalChange(toDeleteTableItem: boolean,
    item: models.BeneficiaryListVM, isServiceOrFunerary: boolean,
    legalRepresentativeIsNotSender: boolean) {
    if (isServiceOrFunerary) {
      const validationDocAppear = this.prestacoesMorteValueObserverService
        .legalRepresentativeBeneficiaryValidation(item.hasLegalRepresentation, legalRepresentativeIsNotSender);

      if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeLegalRepresentativeBeneficiaryNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
      } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeLegalRepresentativeBeneficiaryNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
      }
    }
  }

  public docBeneficiaryRepresentacaoLegalCertidaoChange(toDeleteTableItem: boolean,
    item: models.BeneficiaryListVM, isServiceOrFunerary: boolean,
    legalRepresentativeIsNotSender: boolean) {
    if (isServiceOrFunerary) {
      const validationDocAppear = this.prestacoesMorteValueObserverService
        .legalRepresentativeCertidaoBeneficiaryValidation(item.hasLegalRepresentation, legalRepresentativeIsNotSender);

      if (toDeleteTableItem || !validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeLegalRepresentativeCertidaoBeneficiaryNotification(false, item.beneficiaryName, item.NIF, item.beneficiaryID);
      } else if (validationDocAppear) {
        this.prestacoesMorteValueObserverService
          .changeLegalRepresentativeCertidaoBeneficiaryNotification(true, item.beneficiaryName, item.NIF, item.beneficiaryID);
      }
    }
  }

  public getErrorsOnHabilitando(beneficiary: models.BeneficiaryListVM): ErrorsOnBeneficiary {
    const erros = this.errorsOnBeneficiaries.find(el => el.id == beneficiary.beneficiaryID);
    return erros;
  }

  private addHabilitandosError(erro: ErrorsOnBeneficiary) {
    const toRemove = this.errorsOnBeneficiaries.filter(el => el.id == erro.id);
    const filteredArray = this.errorsOnBeneficiaries.filter(function (x) {
      return toRemove.indexOf(x) < 0;
    });
    this.errorsOnBeneficiaries = filteredArray;
    this.errorsOnBeneficiaries.push(erro);
  }

  public isBeneficiaryValid(el: models.BeneficiaryListVM): boolean {
    let result = true;
    const stringKeyTranslation = 'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.';
    const errorsOnBeneficiary: ErrorsOnBeneficiary = {
      beneficiary: el.beneficiaryName,
      id: el.beneficiaryID,
      missingFields:[]
    }

    let benefitChoosen = null;
    const isOnlyRDFBenefit = el.reimbursementFuneralBenefit?.toString() == 'true' &&
      el.funeralAllowanceBenefit?.toString() != 'true' &&
      el.survivalPensionBenefit?.toString() != 'true';

    const isOnlySOBenefit = el.reimbursementFuneralBenefit?.toString() != 'true' &&
      el.funeralAllowanceBenefit?.toString() != 'true' &&
      el.survivalPensionBenefit?.toString() == 'true';

    const isOnlySMBenefit = el.reimbursementFuneralBenefit?.toString() != 'true' &&
      el.funeralAllowanceBenefit?.toString() == 'true' &&
      el.survivalPensionBenefit?.toString() != 'true';

    if (isOnlyRDFBenefit) {
      benefitChoosen = BenefitChoosen.ReimbursementFuneral;
    } else {
      if (isOnlySOBenefit) {
        benefitChoosen = BenefitChoosen.SurvivalPension;
      } else {
        if (isOnlySMBenefit) {
          benefitChoosen = BenefitChoosen.FuneralAllowance;
        } else {
          benefitChoosen = BenefitChoosen.MoreThanOne;
        }
      }
    }

    result = result && isNotNullOrUndefinedOrEmpty(el.personTypologyCode);
    const requereuBeneficio = el.funeralAllowanceBenefit?.toString() == 'true' ||
      el.survivalPensionBenefit?.toString() == 'true' ||
      el.reimbursementFuneralBenefit?.toString() == 'true';
    result = result && requereuBeneficio;
    if (!result) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :requereuBeneficio`);
      errorsOnBeneficiary.missingFields.push({
        name: 'requereuBeneficio',
        translation: 'Escolher um dos benefícios'
      });
    }

    if (benefitChoosen != BenefitChoosen.SurvivalPension) {
      const SSReceived = isNotNullOrUndefinedOrEmpty(el.SSReceived)
      result = result && SSReceived;
      if (!SSReceived) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :SSReceived`);
        errorsOnBeneficiary.missingFields.push({
          name: 'SSReceived',
          key: stringKeyTranslation + 'BenefitType.Fields.SSReceived'
        });

      }

    }


    if (el.funeralAllowanceBenefit?.toString() == 'true' && !isOnlyRDFBenefit) {
      const livedWithDeceased = isNotNullOrUndefinedOrEmpty(el.livedWithDeceased);
        result = result && livedWithDeceased;
      if (!livedWithDeceased) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :livedWithDeceased`);
        errorsOnBeneficiary.missingFields.push({
          name: 'livedWithDeceased',
          key: stringKeyTranslation + 'BenefitType.Fields.LivedWithDeceased'
        });
      }
    }


    if (el.reimbursementFuneralBenefit?.toString() == 'true') {
      const funeralExpense = isNotNullOrUndefinedOrEmpty(el.funeralExpense);
        result = result && funeralExpense;
      if (!funeralExpense) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :funeralExpense`);
        errorsOnBeneficiary.missingFields.push({
          name: 'funeralExpense',
          key: stringKeyTranslation + 'BenefitType.Fields.FuneralExpense'
        });
      }

    }

    const beneficiaryName = isNotNullOrUndefinedOrEmpty(el.beneficiaryName);
    result = result && beneficiaryName;
    if (!beneficiaryName) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :beneficiaryName`);
      errorsOnBeneficiary.missingFields.push({
        name: 'beneficiaryName',
        key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.Name'
      });
    }


    if (el.personTypologyCode == this.personTypologyValues.Singular) {
      const dateOfBirth = isNotNullOrUndefinedOrEmpty(el.dateOfBirth);
      result = result && dateOfBirth;
      if (!dateOfBirth) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :dateOfBirth`);
        errorsOnBeneficiary.missingFields.push({
          name: 'dateOfBirth',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.DateOfBirth'
        });
      }

      const hasNacPT = isNotNullOrUndefinedOrEmpty(el.hasNacPT);
      result = result && hasNacPT;
      if (!hasNacPT) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasNacPT`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasNacPT',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.HasNacPT'
        });
      }


      const hasNIFPT = isNotNullOrUndefinedOrEmpty(el.hasNIFPT);
      result = result && hasNIFPT;
      if (!hasNIFPT) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasNIFPT`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasNIFPT',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.HasNIFPT'
        });
      }
      if (el.hasNIFPT?.toString() == 'true') {
        
        const NIF = isNotNullOrUndefinedOrEmpty(el.NIF);
        result = result && NIF;
        if (!NIF) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :NIF`);
          errorsOnBeneficiary.missingFields.push({
            name: 'NIF',
            key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.NIF'
          });
        }
      }

      
      const nationality = isNotNullOrUndefinedOrEmpty(el.nationality);
      result = result && nationality;
      if (!nationality) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :nationality`);
        errorsOnBeneficiary.missingFields.push({
          name: 'nationality',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.Nationality'
        });
      }

      const gender = isNotNullOrUndefinedOrEmpty(el.gender);
      result = result && gender;
      if (!gender) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :gender`);
        errorsOnBeneficiary.missingFields.push({
          name: 'gender',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.Gender'
        });
      }

  
      const civilStateDeathDate = isNotNullOrUndefinedOrEmpty(el.civilStateDeathDate);
      result = result && civilStateDeathDate;
      if (!civilStateDeathDate) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :civilStateDeathDate`);
        errorsOnBeneficiary.missingFields.push({
          name: 'civilStateDeathDate',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.CivilStateDeathDate'
        });
      }

      
      const identificationDocumentType = isNotNullOrUndefinedOrEmpty(el.identificationDocumentType);
      result = result && identificationDocumentType;
      if (!identificationDocumentType) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :identificationDocumentType`);
        errorsOnBeneficiary.missingFields.push({
          name: 'identificationDocumentType',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.IdentificationDocumentType'
        });
      }

      const identificationNumberFirst = isNotNullOrUndefinedOrEmpty(el.identificationNumberFirst);
      result = result && identificationNumberFirst;
      if (!identificationNumberFirst) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :identificationNumberFirst`);
        errorsOnBeneficiary.missingFields.push({
          name: 'identificationNumberFirst',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.IdentificationNumberFirst'
        });
      }
    }



    if (el.personTypologyCode == this.personTypologyValues.Singular) {

      const NISS = isNotNullOrUndefinedOrEmpty(el.NISS);
      result = result && NISS;
      if (!NISS) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :NISS`);
        errorsOnBeneficiary.missingFields.push({
          name: 'NISS',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.NISS'
        });
      }


      const financialService = isNotNullOrUndefinedOrEmpty(el.financialService);
      result = result && financialService;
      if (!financialService) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :financialService`);
        errorsOnBeneficiary.missingFields.push({
          name: 'financialService',
          key: stringKeyTranslation + 'BeneficiaryIdentification.Fields.FinancialService'
        });
      }


        
      const countryCode = isNotNullOrUndefinedOrEmpty(el.countryCode);
      result = result && countryCode;
      if (!countryCode) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :countryCode`);
        errorsOnBeneficiary.missingFields.push({  
          name: 'countryCode',
          key: stringKeyTranslation + 'BeneficiaryContacts.Fields.Country'
        });
      }

      
      const address = isNotNullOrUndefinedOrEmpty(el.address);
      result = result && address;
      if (!address) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :address`);
        errorsOnBeneficiary.missingFields.push({
          name: 'address',
          key: stringKeyTranslation + 'BeneficiaryContacts.Fields.Address'
        });
      }



      if (el.countryCode == 'PT') {

        const postalCodeFirst = isNotNullOrUndefinedOrEmpty(el.postalCodeFirst);
        result = result && postalCodeFirst;
        if (!postalCodeFirst) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :postalCodeFirst`);
          errorsOnBeneficiary.missingFields.push({
            name: 'postalCodeFirst',
            translation:"Postal Code (0000)"
          });
        }

        const postalCodeLast = isNotNullOrUndefinedOrEmpty(el.postalCodeLast);
        result = result && postalCodeLast;
        if (!postalCodeLast) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :postalCodeLast`);
          errorsOnBeneficiary.missingFields.push({
            name: 'postalCodeLast',
            translation: "Postal Code (000)"
          });
        }
      } else {
        if (isNotNullOrUndefinedOrEmpty(el.countryCode)) {
          const postalCodeFull = isNotNullOrUndefinedOrEmpty(el.postalCodeFull);
          result = result && postalCodeFull;
          if (!postalCodeFull) {
            console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :postalCodeFull`);
            errorsOnBeneficiary.missingFields.push({
              name: 'postalCodeFull',
              translation: "Postal Code Estrangeiro"
            });
          }
        }
      }
    }

    const mobileNumber = isNotNullOrUndefinedOrEmpty(el.mobileNumber);
    result = result && mobileNumber;
    if (!mobileNumber) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :mobileNumber`);
      errorsOnBeneficiary.missingFields.push({
        name: 'mobileNumber',
        key: stringKeyTranslation + 'BeneficiaryContacts.Fields.MobileNumber'
      });
    }



    const email = isNotNullOrUndefinedOrEmpty(el.email);
    result = result && email;
    if (!email) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :email`);
      errorsOnBeneficiary.missingFields.push({
        name: 'email',
        key: stringKeyTranslation + 'BeneficiaryContacts.Fields.Email'
      });
    }

    
    const deceasedRelationship = isNotNullOrUndefinedOrEmpty(el.deceasedRelationship);
    result = result && deceasedRelationship;
    if (!deceasedRelationship) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :deceasedRelationship`);
      errorsOnBeneficiary.missingFields.push({
        name: 'deceasedRelationship',
        key: stringKeyTranslation + 'DeceasedRelationship.Fields.DeceasedRelationship'
      });
    }

    if (el.deceasedRelationship == this.deceasedRelationshipValues.Outros && !isOnlyRDFBenefit) {
      const otherDeceasedRelationship = isNotNullOrUndefinedOrEmpty(el.otherDeceasedRelationship);
      result = result && otherDeceasedRelationship;
      if (!otherDeceasedRelationship) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :otherDeceasedRelationship`);
        errorsOnBeneficiary.missingFields.push({
          name: 'otherDeceasedRelationship',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.OtherDeceasedRelationship'
        });
      }
    }

    if (el.deceasedRelationship == this.deceasedRelationshipValues.Conjugue && !isOnlyRDFBenefit) {
   
      const marriageDate = isNotNullOrUndefinedOrEmpty(el.marriageDate);
      result = result && marriageDate;
      if (!marriageDate) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :marriageDate`);
        errorsOnBeneficiary.missingFields.push({
          name: 'marriageDate',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.MarriageDate'
        });
      }
    
    }

    if (el.survivalPensionBenefit?.toString() == "true" && !isOnlyRDFBenefit) {
      if (el.deceasedRelationship == this.deceasedRelationshipValues.ExConjugue ) {
        const hasCourtAlimony = isNotNullOrUndefinedOrEmpty(el.hasCourtAlimony);
        result = result && hasCourtAlimony;
        if (!hasCourtAlimony) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasCourtAlimony`);
          errorsOnBeneficiary.missingFields.push({
            name: 'hasCourtAlimony',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasCourtAlimony'
          });
        }

        if (el.hasCourtAlimony?.toString() == 'true') {
          const alimonyValueDeathDate = isNotNullOrUndefinedOrEmpty(el.alimonyValueDeathDate);
          result = result && alimonyValueDeathDate;
          if (!alimonyValueDeathDate) {
            console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :alimonyValueDeathDate`);
            errorsOnBeneficiary.missingFields.push({
              name: 'alimonyValueDeathDate',
              key: stringKeyTranslation + 'DeceasedRelationship.Fields.AlimonyValueDeathDate'
            });
          }
        }
      }

    }


    if (el.deceasedRelationship == this.deceasedRelationshipValues.UniaoDeFacto && !isOnlyRDFBenefit) {
      const startDateCohabitation = isNotNullOrUndefinedOrEmpty(el.startDateCohabitation);
      result = result && startDateCohabitation;
      if (!startDateCohabitation) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :startDateCohabitation`);
        errorsOnBeneficiary.missingFields.push({
          name: 'startDateCohabitation',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.StartDateCohabitation'
        });
      }
    
    }

    if ((el.deceasedRelationship == this.deceasedRelationshipValues.Enteado ||
      el.deceasedRelationship == this.deceasedRelationshipValues.Netos) && !isOnlyRDFBenefit) {
      
      const hasChargeDeceased = isNotNullOrUndefinedOrEmpty(el.hasChargeDeceased);
      result = result && hasChargeDeceased;
      if (!hasChargeDeceased) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasChargeDeceased`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasChargeDeceased',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasChargeDeceased'
        });
      }

    }

    if ((el.deceasedRelationship == this.deceasedRelationshipValues.Pais ||
      el.deceasedRelationship == this.deceasedRelationshipValues.Avos) && !isOnlyRDFBenefit) {
      const monthlyncome = isNotNullOrUndefinedOrEmpty(el.monthlyncome);
      result = result && monthlyncome;
      if (!monthlyncome) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :monthlyncome`);
        errorsOnBeneficiary.missingFields.push({
          name: 'monthlyncome',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.MonthlyIncome'
        });
      }

      const hasIRSExemption = isNotNullOrUndefinedOrEmpty(el.hasIRSExemption);
      result = result && hasIRSExemption;
      if (!hasIRSExemption) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasIRSExemption`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasIRSExemption',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasIRSExemption'
        });
      }

    }

    if (((el.deceasedRelationship == this.deceasedRelationshipValues.Filhos && DateHelpers.isAdult(el.dateOfBirth)) ||

      el.deceasedRelationship == this.deceasedRelationshipValues.Netos && el.hasChargeDeceased?.toString()=='true') && !isOnlyRDFBenefit) {
      
      const scholarSituationDeathDate = isNotNullOrUndefinedOrEmpty(el.scholarSituationDeathDate);
      result = result && scholarSituationDeathDate;
      if (!scholarSituationDeathDate) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :scholarSituationDeathDate`);
        errorsOnBeneficiary.missingFields.push({
          name: 'scholarSituationDeathDate',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.ScholarSituationDeathDate'
        });
      }
      if (isNotNullOrUndefinedOrEmpty(el.scholarSituationDeathDate) && el.scholarSituationDeathDate != this.scholarSituationValues.NaoColocado) {
        
        const educationLevelDeathDate = isNotNullOrUndefinedOrEmpty(el.educationLevelDeathDate);
        result = result && educationLevelDeathDate;
        if (!educationLevelDeathDate) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :educationLevelDeathDate`);
          errorsOnBeneficiary.missingFields.push({
            name: 'educationLevelDeathDate',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.EducationLevelDeathDate'
          });
        }

        const registrationYear = isNotNullOrUndefinedOrEmpty(el.registrationYear);
        result = result && registrationYear;
        if (!registrationYear) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :registrationYear`);
          errorsOnBeneficiary.missingFields.push({
            name: 'registrationYear',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.RegistrationYear'
          });
        }
      }
    }

    if (((el.funeralAllowanceBenefit?.toString() == 'true' ||
      el.survivalPensionBenefit?.toString() == 'true') &&
      ((el.deceasedRelationship == this.deceasedRelationshipValues.Filhos && DateHelpers.isAdult(el.dateOfBirth)) ||
      (el.deceasedRelationship == this.deceasedRelationshipValues.Netos && el.hasChargeDeceased?.toString() == 'true')  
      )) && !isOnlyRDFBenefit) {
      const activeProfessionalSituation = isNotNullOrUndefinedOrEmpty(el.activeProfessionalSituation);
      result = result && activeProfessionalSituation;
      if (!activeProfessionalSituation) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :activeProfessionalSituation`);
        errorsOnBeneficiary.missingFields.push({
          name: 'activeProfessionalSituation',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.ActiveProfessionalSituation'
        });
      }

      if (el.activeProfessionalSituation?.toString() == 'true') {
        const professionalSituation = isNotNullOrUndefinedOrEmpty(el.professionalSituation);
        result = result && professionalSituation;
        if (!professionalSituation) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :professionalSituation`);
          errorsOnBeneficiary.missingFields.push({
            name: 'professionalSituation',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.ProfessionalSituation'
          });
        }



        const startDateProfession = isNotNullOrUndefinedOrEmpty(el.startDateProfession);
        result = result && startDateProfession;
        if (!startDateProfession) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :startDateProfession`);
          errorsOnBeneficiary.missingFields.push({
            name: 'startDateProfession',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.StartDateProfession'
          });
        }

        
        const income = isNotNullOrUndefinedOrEmpty(el.income);
        result = result && income;
        if (!income) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :income`);
          errorsOnBeneficiary.missingFields.push({
            name: 'income',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.Income'
          });
        }

      }
    }

    if (!isOnlyRDFBenefit) {
      const hasIncapacity = isNotNullOrUndefinedOrEmpty(el.hasIncapacity);
      result = result && hasIncapacity;
      if (!hasIncapacity ) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasIncapacity`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasIncapacity',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasIncapacity'
        });
      }
    }

    if (el.hasIncapacity?.toString() == 'true' && !isOnlyRDFBenefit) {
      const hasSocialPension = isNotNullOrUndefinedOrEmpty(el.hasSocialPension);
      result = result && hasSocialPension;
      if (!hasSocialPension) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasSocialPension`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasSocialPension',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasSocialPension'
        });
      }
      if (el.hasSocialPension?.toString() == 'true') {
        const socialPensionDate = isNotNullOrUndefinedOrEmpty(el.socialPensionDate);
        result = result && socialPensionDate;
        if (!socialPensionDate) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :socialPensionDate`);
          errorsOnBeneficiary.missingFields.push({
            name: 'socialPensionDate',
            key: stringKeyTranslation + 'DeceasedRelationship.Fields.SocialPensionDate'
          });
        }
      }
    }

    if (!isOnlyRDFBenefit) {
      const hasJudicialInterdiction = isNotNullOrUndefinedOrEmpty(el.hasJudicialInterdiction);
      result = result && hasJudicialInterdiction;
      if (!hasJudicialInterdiction) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasJudicialInterdiction`);
        errorsOnBeneficiary.missingFields.push({
          name: 'hasJudicialInterdiction',
          key: stringKeyTranslation + 'DeceasedRelationship.Fields.HasJudicialInterdiction'
        });
      }
    }
    //const hasLegalRepresentation = isNotNullOrUndefinedOrEmpty(el.hasLegalRepresentation);
    //result = result && hasLegalRepresentation;
    //if (!hasLegalRepresentation) {
    //  console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :hasLegalRepresentation`);
    //  errorsOnBeneficiary.missingFields.push({
    //    name: 'hasLegalRepresentation',
    //    key: stringKeyTranslation + 'LegalRepresentationIdentification.Fields.HasLegalRepresentation'
    //  });
    //}


    if (el.hasLegalRepresentation?.toString() == 'true') {
      const legalRepresentationName = isNotNullOrUndefinedOrEmpty(el.legalRepresentationName);
      result = result && legalRepresentationName;
      if (!legalRepresentationName) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :legalRepresentationName`);
        errorsOnBeneficiary.missingFields.push({
          name: 'legalRepresentationName',
          key: stringKeyTranslation + 'LegalRepresentationIdentification.Fields.LegalRepresentationName'
        });
      }

      const representationType = isNotNullOrUndefinedOrEmpty(el.representationType);
      result = result && representationType;
      if (!representationType) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :representationType`);
        errorsOnBeneficiary.missingFields.push({
          name: 'representationType',
          key: stringKeyTranslation + 'LegalRepresentationIdentification.Fields.RepresentationType'
        });
      }
    }

    if ((el.survivalPensionBenefit?.toString() == 'true' || el.funeralAllowanceBenefit?.toString() == 'true') &&
      el.personTypologyCode == this.personTypologyValues.Singular && !isOnlyRDFBenefit) {

      const irsTableCode = isNotNullOrUndefinedOrEmpty(el.irsTableCode);
      result = result && irsTableCode;
      if (!irsTableCode) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :irsTableCode`);
        errorsOnBeneficiary.missingFields.push({
          name: 'irsTableCode',
          key: stringKeyTranslation + 'TaxInformation.Fields.IRSTable'
        });
      }

      if (el.irsTableCode == 'DEF') {
        const desvalorizationPercentage = isNotNullOrUndefinedOrEmpty(el.desvalorizationPercentage);
        result = result && desvalorizationPercentage;
        if (!desvalorizationPercentage) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :desvalorizationPercentage`);
          errorsOnBeneficiary.missingFields.push({
            name: 'desvalorizationPercentage',
            key: stringKeyTranslation + 'TaxInformation.Fields.DevaluationPercentage'
          });
        }
      }

      const revenueTitularityCode = isNotNullOrUndefinedOrEmpty(el.revenueTitularityCode);
      result = result && revenueTitularityCode;
      if (!revenueTitularityCode) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :revenueTitularityCode`);
        errorsOnBeneficiary.missingFields.push({
          name: 'revenueTitularityCode',
          key: stringKeyTranslation + 'TaxInformation.Fields.IncomeOwnership'
        });
      }
    }

    const bankAccount = isNotNullOrUndefinedOrEmpty(el.bankAccount);
    result = result && bankAccount;
    if (!bankAccount) {
      console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :bankAccount`);
      errorsOnBeneficiary.missingFields.push({
        name: 'bankAccount',
        key: stringKeyTranslation + 'Payment.Fields.BankAccount'
      });
    }
    if (el.bankAccount == 'N') {

      const iban = isNotNullOrUndefinedOrEmpty(el.iban);
      result = result && iban;
      if (!iban) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :iban`);
        errorsOnBeneficiary.missingFields.push({
          name: 'iban',
          key: stringKeyTranslation + 'Payment.Fields.IBAN'
        });
      }

      const isSoleHolder = isNotNullOrUndefinedOrEmpty(el.isSoleHolder);
      result = result && isSoleHolder;
      if (!isSoleHolder) {
        console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :isSoleHolder`);
        errorsOnBeneficiary.missingFields.push({
          name: 'isSoleHolder',
          key: stringKeyTranslation + 'Payment.Fields.SoleHolder'
        });
      }

      if (el.isSoleHolder?.toString() == 'false') {

        const coholderName = isNotNullOrUndefinedOrEmpty(el.coholderName);
        result = result && coholderName;
        if (!coholderName) {
          console.log(`Campo em falta no beneficiario  ${el.beneficiaryName} :coholderName`);
          errorsOnBeneficiary.missingFields.push({
            name: 'coholderName',
            key: stringKeyTranslation + 'Payment.Fields.CoholderName'
          });
        }
      }
    }

    this.addHabilitandosError(errorsOnBeneficiary);
    return result;
  }

}

